<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="bg--white border-radius m-t-25 m-b-25 p-30">
                <h1>
                    Dashboard
                </h1>
                <Notifications class="dasboard-widget"></Notifications>
                <div class="row">
                    <div class="col-lg-6">
                        <CandidatePartners class="dasboard-widget"></CandidatePartners>
                        <CandidateOffers class="dasboard-widget"></CandidateOffers>
                    </div>
                    <div class="col-lg-6">
                        <OilPriceTable class="dasboard-widget"></OilPriceTable>
                        <CarAttest class="dasboard-widget"></CarAttest>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import OilPriceTable from "../../widgets/FuelPriceTable.vue";
    import CarAttest from "../../widgets/CarAttest.vue";
    import Notifications from "../../widgets/Notifications.vue";
    import CandidatePartners from "../../widgets/Candidatepartners.vue";
    import CandidateOffers from "../../widgets/CandidateOffers.vue";
    import LineChart from "../../widgets/LineChart.vue";

    export default {
        name: 'Dashboard',
        components: {
            LineChart,
            OilPriceTable,
            CarAttest,
            Notifications,
            CandidatePartners,
            CandidateOffers,

        },
        data() {
            return {
                menu: [],
                currentUrl: window.location.href
            }
        },
        created() {
            const userInterface = this.$userInterfaceHandler.getUserInterface();
            if (userInterface) {
                this.menu = userInterface.menu;
            }
        }
    }
</script>
